import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/login2.vue')
    // component: () => import('@/login.vue')
  }
]
const router = new VueRouter({
  routes
})

export default router